import buildService from '../../helper/service'

// 值类型为String或Object,String为url(method),Object同axios(config)参数支持相同,data和params只能为对象类型
const settings = {
  // 获取用户可访问的页面
  getUserMenu: {
    url: '/adminc/v1/resource_manage/p_menu/get_menu_cate_list',
    method: 'get'
  }
}

export default buildService(settings)



// WEBPACK FOOTER //
// ./src/services/user/userInfo.js